/*
 * Copyright (c) 2020. American Express Company
 */

// theirs
import _ from 'lodash';
import React, { Component, ReactComponentElement } from 'react';

// models and services
import { CardModel } from 'src/types/card.model';
import { CashFlowModel } from 'src/types/cash-flow.model';
import CashFlowService from '../../services/cashflow.service';
import FormatService from '../../services/format.service';
import LiteralsService from '../../services/literals/LiteralsService';

// components
import BwSlider from '../bw-slider/BwSlider';
import GoalDrawer from './GoalDrawer';
import InfoCallout from '../callout/InfoCallout';
import Output from '../atomic/molecules/output/Output';

// icons and styles
import { ReactComponent as CharityIcon } from 'src/bw/goal/charity.svg';

export default class CharityDrawer extends Component<
    any,
    {
        cardId: number;
        costChanged: boolean;
    }
> {
    public override state = {
        cardId: this.props.drawerProps.card.id,
        costChanged: false
    };

    public override render(): ReactComponentElement<any> {
        const drawerProps: any = this.props.drawerProps;
        const card: CardModel = drawerProps.card;

        const marks = [
            {
                value: 1,
                label: '1%'
            },
            {
                value: 100,
                label: '100%'
            }
        ];

        const offset: number = CashFlowService.getCashFlowIndexWithDate(this.props.user.rawCashFlow, card.startDate);

        let totalCharity: number = 0;
        let totalIncome: number = 0;

        for (let i = 1; i < 13; i++) {
            const cashFlow: CashFlowModel = this.props.user.rawCashFlow[offset - i];
            totalIncome += cashFlow?.income;
        }

        const summary: any = _.find(drawerProps.summaries, {
            name: 'Donations & Gifts'
        });
        if (summary) totalCharity += summary.total as number;

        let charityPercentage = 0;
        let annual = 0;

        if (totalIncome) {
            annual = (card.attributes.percentage * totalIncome) / 100;
            charityPercentage = (totalCharity / totalIncome) * 100;
        }
        const monthly = annual / 12;

        return (
            <GoalDrawer
                drawerProps={drawerProps}
                handleBack={this.props.handleBack}
                handleUpdateCard={this.props.handleUpdateCard}
                handleChangeCard={this.props.handleChangeCard}
                handleDeleteCard={this.props.handleDeleteCard}
                showLoader={this.props.showLoader}
                hideLoader={this.props.hideLoader}
                icon={<CharityIcon />}
                introContent={LiteralsService.getLiteral('CharityDrawer.body')}
                cashFlow={this.props.user.cashFlow}
                handleChangeCardDate={this.props.handleChangeCardDate.bind(this)}
                hasEndDate
            >
                <div className="drawerSection">
                    <BwSlider
                        id="percentage-slider"
                        label="Percent of annual income to donate"
                        value={card.attributes.percentage}
                        formattedValue={FormatService.formatPercent(card.attributes.percentage, 0)}
                        step={1}
                        marks={marks}
                        min={1}
                        max={100}
                        onChange={(value: any) =>
                            this.props.handleChangeCardAttribute(card, value, 'percentage', 'number')
                        }
                        isPercentage
                    />
                    <InfoCallout
                        text={`Based on your expenses you currently spend ${FormatService.formatPercent(
                            charityPercentage,
                            0
                        )} of
                        your income on charity.`}
                        noMargin
                    />
                </div>

                <Output
                    title="Annual income to donate"
                    main={FormatService.format(annual)}
                    subtext={`${FormatService.format(monthly)} per month`}
                    tooltipText={LiteralsService.getLiteral('CharityDrawer.tax')}
                />
            </GoalDrawer>
        );
    }
}
